"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.control = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var control = function control(provided, state) {
  var menuIsOpen = state.menuIsOpen;
  var boxShadowMenuIsOpen = '0 2px 5px rgba(60, 66, 87, 0.08), 0 1px 1px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(60, 66, 87, 0.16), 0 0 0 4px rgba(58, 151, 212, 0.36)';
  return _objectSpread(_objectSpread({}, provided), {}, {
    borderColor: 'transparent',
    backgroundColor: '#fff',
    boxShadow: menuIsOpen ? boxShadowMenuIsOpen : '0 2px 5px rgba(60, 66, 87, 0.08), 0 1px 1px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(60, 66, 87, 0.16)',
    cursor: 'pointer',
    '&:hover': _objectSpread(_objectSpread({}, provided['&:hover']), {}, {
      borderColor: null,
      boxShadow: menuIsOpen ? boxShadowMenuIsOpen : '0 3px 9px rgba(60, 66, 87, 0.08), 0 2px 5px rgba(60, 66, 87, 0.08), 0 1px 1px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(60, 66, 87, 0.16)'
    }),
    justifyContent: 'flex-start',
    flexWrap: 'nowrap'
  });
};

exports.control = control;